import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { SharedModule } from '../../shared/shared.module';
import { routing } from './user-settings.routing';

import { UserSettingsComponent } from './user-settings.component';
import { UserComponent } from './user/user.component';
import { GroupComponent } from './group/group.component';
import { UserSettingsService } from './user-settings.service';
import { MatRadioModule } from '@angular/material/radio';
import { GroupOperatorComponent } from './group-operator/group-operator.component';

@NgModule({
  declarations: [UserSettingsComponent, UserComponent, GroupComponent,GroupOperatorComponent],
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    NgxPaginationModule,
    MatRadioModule,
    routing,
  ],
  providers: [UserSettingsService],
})
export class UserSettingsModule {}
